import { createStorageNamespace } from '@/modules/f8/hooks/storage/storage';

const globalStorage = createStorageNamespace('shared');

export function useGlobalStorage() {
  return {
    get: globalStorage.get,
    set: globalStorage.set,
    ref: globalStorage.ref,
    clear: globalStorage.clear,
    rawRef: globalStorage.rawRef,
  };
}

const authStorage = createStorageNamespace('auth');

export function useAuthStorage() {
  return {
    get: authStorage.get,
    set: authStorage.set,
    ref: authStorage.ref,
    clear: authStorage.clear,
    rawRef: authStorage.rawRef,
  };
}